import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import '../../style.scss';
import { loadPaymentsMethodList } from 'redux/actions/paymentActions';
import { makeDefaultPaymentMethod, deletePaymentMethod } from 'api/paymentApi';
import LoadingAnimation from 'components/common/LoadingAnimation';
import ConfirmModal from 'components/common/ConfirmModal';
const CheckedIcon = 'assets/img/payment/checked.svg';
const InactiveIcon = 'assets/img/payment/inactive.svg';
const MapBg = 'assets/img/payment/map.png';
const GlobeBg = 'assets/img/payment/globe.png';
const Chip = 'assets/img/payment/chip.png';
const Rfid = 'assets/img/payment/signal-stream.png';
const Close = 'assets/img/payment/delete.png';
const EftCard = ({ card }) => {
  const { brand, id, isDefault, expiry, last4, payment_type } = card || {};
  const [isLoading, setIsLoading] = useState(false);
  const [showRemoveCard, setshowRemoveCard] = useState(false);
  const dispatch = useDispatch();
  const handleSetDefault = async id => {
    try {
      setIsLoading(true);
      await makeDefaultPaymentMethod(id);
      await dispatch(loadPaymentsMethodList());
      const channel = new BroadcastChannel('card_channel');
      channel.postMessage({
        ...card,
        isDefault: !isDefault,
        name: card?.description,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  const handleDeleteCard = async () => {
    try {
      setIsLoading(true);
      await deletePaymentMethod(id);
      await dispatch(loadPaymentsMethodList());
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  const Loader = useMemo(() => {
    if (isLoading) {
      return <LoadingAnimation />;
    }
    return null;
  }, [isLoading]);

  const ConfirmModalMemorized = useMemo(() => {
    if (showRemoveCard) {
      return (
        <ConfirmModal
          show
          description="Are you sure you want to remove this payment method?"
          confirmText="Remove"
          onConfirm={handleDeleteCard}
          onClose={() => {
            setshowRemoveCard(false);
          }}
        />
      );
    }
    return null;
  }, [showRemoveCard, handleDeleteCard, setshowRemoveCard]);

  return (
    <>
      {ConfirmModalMemorized}
      {Loader}
      <div
        key={id}
        className={`card-inner justify-content-between ${isDefault ? 'active' : null
          } ${card.paymentType === 'acss_debit' && 'acss-debit-card'}`}
      >
        <div onClick={() => setshowRemoveCard(true)} className='delete-card'>
          <img src={Close} alt='close button' />
        </div>
        {card.paymentType === 'acss_debit' ?
          <img className="map-img" src={GlobeBg} /> : <img className="map-img" src={MapBg} />
        }
        <img className="chip-img" src={Chip} />
        <img className="rfid-img" src={Rfid} />

        <div className="cardheader d-block">
          <div className="form-group mb-0 checkbox">
            <div
              className="custom-checkbox"
              onClick={e => handleSetDefault(id)}
            >
              {isDefault ? (
                <span>
                  <img src={CheckedIcon} />
                </span>
              ) : (
                <span>
                  <img src={InactiveIcon} />
                </span>
              )}
            </div>
            <label className="mb-0 text-white flex-fill text-left">
              {isDefault ? (
                <span className="text-white">Default</span>
              ) : (
                <span className="text-dark">Mark as Default</span>
              )}
            </label>
            <h5 className='mb-0 font-weight-bold'>{brand}</h5>
          </div>
        </div>
        <div className=" form-group mb-0 card-number">
          <label htmlFor={`cardNumber-${id}`}>Bank Account Number:</label>
          <div className="input-wrap">
            {last4 ? (
              <>
                <span>**** **** **** {last4}</span>
              </>
            ) : (
              <span>0000 0000 0000 0000</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EftCard;
